<template>
	<div id="wrap">
		<div class="layout-con">
			<div class="wrap-right">
				<div class="v3-main">
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'layout'
}
</script>

<style lang="less">
#app{
	width: 100%; height: 100%;
	#wrap{
		width: 100%; height: 100%;
		.wrap-right{
			overflow: hidden;
			.el-row{
					height: 50px; box-sizing: border-box; background: #fff; border-bottom: 1px solid #ededed; display: flex; align-items: center; justify-content: space-between; padding: 0 0 0 14px;
			}
			.myTable{ border: 1px solid #dfe2ea;}
			.searchInfo{ background-color: #f4f4f4; border-bottom: none;}
			.tableStyle{ border: none;}
		}
	}
}
.layout-con{
	width: 100%;
	padding-top: 0;
	min-height: 100vh;
}

</style>
